import { Content, Heading, IllustratedMessage, Link, LinkButton, Paragraph } from "@hopper-ui/components";
import { ErrorIllustration } from "@sg-protect/components";
import { Trans } from "@sg-protect/federation-runtime/i18n";
import { useShellTranslation } from "../i18n/i18next.ts";
import { ErrorLayout } from "./ErrorLayout.tsx";

export interface InternalServerErrorProps {
    homeUrl: string;
    variant?: "root" | "nested";
}

export function InternalServerError({ homeUrl, variant = "root" }: InternalServerErrorProps) {
    const { t, i18n } = useShellTranslation();

    return (
        <ErrorLayout variant={variant}>
            <IllustratedMessage size="lg">
                <ErrorIllustration />
                <Heading size="3xl" level={1}>
                    {t("InternalServerError.title")}
                </Heading>
                <Content>
                    <Paragraph marginBottom="stack-xl">{t("InternalServerError.description")}</Paragraph>
                    <Paragraph marginBottom="stack-xl">
                        <Trans
                            i18n={i18n}
                            ns="shell"
                            i18nKey="InternalServerError.contactSupport"
                            components={{
                                supportLink: (
                                    <Link href="https://help.sharegate.com/en/articles/10236088-contact-our-technical-support-team" />
                                )
                            }}
                        />
                    </Paragraph>
                    <LinkButton marginX="auto" href={homeUrl}>
                        {t("InternalServerError.goHome")}
                    </LinkButton>
                </Content>
            </IllustratedMessage>
        </ErrorLayout>
    );
}
